const binding = { modules: {}, dataActions: {} };

    (binding.modules['herbal-anchor-flag'] = {
        c: () => require('partner/modules/herbal-anchor-flag/herbal-anchor-flag.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'herbal-anchor-flag',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/herbal-anchor-flag'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|herbal-anchor-flag|herbal-anchor-flag'] = {
                c: () => require('partner/modules/herbal-anchor-flag/herbal-anchor-flag.view.tsx'),
                cn: '__local__-__local__-herbal-anchor-flag'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };